import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/common/Dialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/common/table/Table";
import { type ReactNode, useState } from "react";
import data from "@/public/data/flight/passengers.json";
import Typography from "@/shared/components/common/Typography";

import Flex from "@/shared/components/common/Flex";
import { Button } from "@/shared/components/common/button";

interface RecentPassengersProps {
  children: ReactNode;
  passengers: RecentPassenger[];
  onSelect: (passenger: RecentPassenger) => void;
}

export default function RecentPassengers({
  children,
  passengers,
  onSelect,
}: RecentPassengersProps) {
  const [searchValue, setSearchValue] = useState("");
  const {
    forms: {
      passengersForm: {
        recentPassegners: {
          dialog: { title, search, table, noPassenger, select },
        },
      },
    },
  } = data;

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="z-100000! max-h-[82dvh] overflow-y-auto sm:max-w-[600px] max-md:w-[calc(100vw-2rem)] max-md:p-4">
        <DialogTitle className="self-center text-center">
          <Typography variant="h5" className="text-foreground font-normal">
            {title}
          </Typography>
        </DialogTitle>

        <Flex className="flex-col">
          {/* <Input
            placeholder={search.placeHolder}
            type={search.type}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            className="rounded-xs"
          /> */}
          <Flex className="py-4 justify-center max-h-[55dvh] overflow-auto">
            {passengers && passengers.length > 0 ? (
              <Table>
                <TableHeader>
                  <TableRow>
                    {table.header.map((head) => (
                      <TableHead key={head} className="text-center">
                        {head}
                      </TableHead>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {passengers
                    .filter(
                      ({ firstname, lastname, identifier }) =>
                        firstname
                          .toLowerCase()
                          .includes(searchValue.toLowerCase()) ||
                        lastname
                          .toLowerCase()
                          .includes(searchValue.toLowerCase()) ||
                        identifier
                          .toLowerCase()
                          .includes(searchValue.toLowerCase()),
                    )
                    .map(
                      (
                        { firstname, lastname, identifier, birthdate_lang },
                        z,
                      ) => (
                        <TableRow
                          key={`${firstname}-${z}`}
                          className="cursor-pointer hover:bg-muted! dark:hover:bg-muted/10!"
                        >
                          <TableCell className="text-center p-4">
                            {firstname} {lastname}
                          </TableCell>
                          <TableCell className="text-center p-4">
                            {identifier}
                          </TableCell>
                          <TableCell className="text-center p-4">
                            {birthdate_lang}
                          </TableCell>
                          <TableCell className="text-center p-4">
                            <DialogClose asChild>
                              <Button
                                className="border-2 border-primary bg-transparent group"
                                onClick={() => onSelect(passengers[z])}
                              >
                                <Typography className="font-normal text-primary group-hover:text-background dark:group-hover:text-foreground ">
                                  {select}
                                </Typography>
                              </Button>
                            </DialogClose>
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                </TableBody>
              </Table>
            ) : (
              <Typography variant="h6" className="font-medium">
                {noPassenger}
              </Typography>
            )}
          </Flex>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
